// File: /opt/dev_environment/assets/workspace/app-init/src/components/ProtectedRoute/ProtectedRoute.js

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * ProtectedRoute wrapper.
 * Redirects to /login if user is not authenticated.
 * Shows a loading spinner while checking auth status.
 */
function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Still checking auth status
  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: 'var(--color-cream-bg)',
      }}>
        <div style={{
          textAlign: 'center',
          color: 'var(--color-text-secondary)',
        }}>
          <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>🗃️</div>
          <div style={{
            fontSize: 'var(--font-size-sm)',
            fontWeight: 'var(--font-weight-semibold)',
          }}>
            Laden…
          </div>
        </div>
      </div>
    );
  }

  // Not authenticated — redirect to login, preserving the intended destination
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}

export default ProtectedRoute;